export const teamMemberFromApi = [
  {
    id: 1,
    img: "https://avatars.githubusercontent.com/u/50624579?v=4",
    name: "Fahra Akhlaq",
    description:
      "Full Stack Web Developer studying at University of Birmingham",
    linkedIn: "https://www.linkedin.com/in/f-akhlaq/",
    github: "https://github.com/fudge88",
    portfolio: "https://fudge88.github.io/react-portfolio/",
  },
  {
    id: 2,
    img: "https://avatars.githubusercontent.com/u/85588396?v=4",
    name: "Luiz Carlos Fróes",
    description:
      " Full Stack Web Developer studying at University of Birmingham",
    linkedIn: "https://www.linkedin.com/in/luiz-froes/",
    github: "https://github.com/luizfroes",
    portfolio: "",
  },
  {
    id: 3,
    img: "https://avatars.githubusercontent.com/u/71083946?v=4",
    name: "Leanne Gallagher",
    description:
      " Full Stack Web Developer studying at University of Birmingham",
    linkedIn: "https://www.linkedin.com/in/leanne-gallagher/",
    github: "https://github.com/lenny-g",
    portfolio: "https://lenny-g.github.io/portfolio/",
  },
  {
    id: 4,
    img: "https://i.ibb.co/GJcdhpp/tayyib.jpg",
    name: "Tayyib Mahmood",
    description:
      "Full Stack Web Developer studying at University of Birmingham",
    linkedIn: "https://lenny-g.github.io/semantic-html-refactor/",
    github: "",
    portfolio: "",
  },
  {
    id: 5,
    img: "https://avatars.githubusercontent.com/u/84455639?v=4",
    name: "Dahir Mohamed",
    description:
      " Full Stack Web Developer studying at University of Birmingham",
    linkedIn: "https://lenny-g.github.io/semantic-html-refactor/",
    github: "https://github.com/DMO17",
    portfolio: "",
  },
  {
    id: 6,
    img: "https://avatars.githubusercontent.com/u/91003882?v=4",
    name: "Anab Warsame",
    description:
      " Full Stack Web Developer studying at University of Birmingham",
    linkedIn: "https://www.linkedin.com/in/anab-warsame-3004b1221/",
    github: "https://github.com/anabwarsame",
    portfolio: "",
  },
];
